/*** GLOBE ****/
window.addEventListener("load", function() {
const PRIMARY = "#3C312D";

/* country -> numeric ISO id (world-atlas), pin coords and fibers */
const DEFAULT_LOCATIONS = [
  { id:"496", key:"mongolia",  name:"Mongolia",    coords:[103.8,46.9], fibers:["Cashmere","Cashmere 4.0"], display:"Cashmere · Yangir"},
  //{ id:"398", key:"kazakhstan",name:"Kazakhstan",  coords:[67.3,48.0],  fibers:["Yangir"],                   display:"Yangir" },
  { id:"156", key:"china",     name:"China",       coords:[107.0,30.0], fibers:["Cashmere","Camel"],        display:"Cashmere · Camel"},
  { id:"604", key:"peru",      name:"Peru",        coords:[-75.0,-9.2], fibers:["Vicuña","Alpaca"],         display:"Vicuña · Alpaca" },
  { id:"068", key:"bolivia",   name:"Bolivia",     coords:[-64.7,-16.3],fibers:["Vicuña"],                  display:"Vicuña" },
  { id:"152", key:"chile",     name:"Chile",       coords:[-71.4,-35.7],fibers:["Vicuña"],                  display:"Vicuña" },
  { id:"032", key:"argentina", name:"Argentina",   coords:[-64.2,-38.4],fibers:["Vicuña"],                  display:"Vicuña" },
  { id:"036", key:"australia", name:"Australia",   coords:[134.5,-25.7],fibers:["Wool"],                    display:"Wool" },
  { id:"554", key:"nzealand",  name:"New Zealand", coords:[172.5,-41.5],fibers:["Wool"],                    display:"Wool" },
];
const linksNode = document.querySelector('[data-lc-globe-links]');
let locationLinks = {};
if(linksNode){
  try {
    locationLinks = JSON.parse(linksNode.textContent);
  } catch(error) {
    console.error("Invalid LC Luxury globe links configuration.", error);
  }
}
const originNodes = Array.from(document.querySelectorAll('[data-lc-origin]'));
const availableKeys = new Set(DEFAULT_LOCATIONS.map(location=>location.key));
const selectedKeys = new Set(originNodes
  .map(node=>node.dataset.key)
  .filter(key=>availableKeys.has(key)));
const persistentTooltipKeys = new Set(originNodes
  .filter(node=>node.dataset.tooltipPersistent==="true")
  .map(node=>node.dataset.key)
  .filter(key=>availableKeys.has(key)));
if(!selectedKeys.size){ selectedKeys.add("mongolia"); }
const LOCATIONS = DEFAULT_LOCATIONS.map(location=>{
  const tooltipLinks = location.key==="mongolia"
    ? [
        { label:"Cashmere", href:locationLinks.mongoliaCashmere || "" },
        { label:"Yangir", href:locationLinks.mongoliaYangir || "" }
      ].filter(link=>link.href)
    : [];
  return {
    ...location,
    href: location.key==="mongolia" ? "" : locationLinks[location.key] || "",
    tooltipLinks,
    active: selectedKeys.has(location.key),
    tooltipPersistent: persistentTooltipKeys.has(location.key)
  };
});
const SOURCE_IDS = new Set(LOCATIONS.map(d=>d.id));
const ACTIVE_KEY = selectedKeys.values().next().value;
const ACTIVE = LOCATIONS.find(d=>d.key===ACTIVE_KEY);

const box = document.getElementById("globeBox");
const svg = d3.select("#globe");
const pinsLayer = document.getElementById("pins");
const hintEl = document.getElementById("hint");

let size=0, R=0, projection, path, graticule, sphere={type:"Sphere"};
let countries=[], pinEls=new Map();
let rotation=[ -20, -12, 0 ];           // current [lambda, phi, gamma]
const TARGET=[ -ACTIVE.coords[0], -(ACTIVE.coords[1]-9), 0 ]; // center near Mongolia, tilted slightly down

/* ---------- build static svg layers ---------- */
const defs = svg.append("defs");
const ocean = defs.append("radialGradient")
  .attr("id","ocean").attr("cx","0.36").attr("cy","0.30").attr("r","0.85");
ocean.append("stop").attr("offset","0%").attr("stop-color","#FCFDFE");
ocean.append("stop").attr("offset","48%").attr("stop-color","#EAEFF5");
ocean.append("stop").attr("offset","82%").attr("stop-color","#CFD9E4");
ocean.append("stop").attr("offset","100%").attr("stop-color","#B7C3D2");

const shade = defs.append("radialGradient")
  .attr("id","shade").attr("cx","0.5").attr("cy","0.5").attr("r","0.5");
shade.append("stop").attr("offset","62%").attr("stop-color","rgba(60,49,45,0)");
shade.append("stop").attr("offset","92%").attr("stop-color","rgba(60,49,45,0.04)");
shade.append("stop").attr("offset","100%").attr("stop-color","rgba(60,49,45,0.16)");

const sphereFill = svg.append("path").attr("class","sphere-fill").attr("fill","url(#ocean)");
const gratPath   = svg.append("path").attr("class","graticule");
const landBase   = svg.append("path").attr("class","land");
const landSrc    = svg.append("path").attr("class","land-source");
const landActive = svg.append("path").attr("class","land-active");
const shadePath  = svg.append("path").attr("fill","url(#shade)").style("pointer-events","none");
const edgePath   = svg.append("path").attr("class","sphere-edge");

graticule = d3.geoGraticule10();

/* ---------- create pin DOM ---------- */
function pinSVG(active){
  // teardrop pin anchored at tip (bottom center of viewBox)
  const ring = active ? `<circle class="ring" cx="15" cy="15" r="9" stroke-width="2"></circle>` : "";
  return `<svg width="${active?40:30}" height="${active?52:39}" viewBox="0 0 30 41">
      <g class="head">
        <path class="pin-body" d="M15 0C7 0 0.5 6.4 0.5 14.3 0.5 24.8 15 41 15 41S29.5 24.8 29.5 14.3C29.5 6.4 23 0 15 0Z"></path>
        <circle class="pin-dot" cx="15" cy="14.3" r="5.4"></circle>
        ${ring}
      </g>
    </svg>`;
}
LOCATIONS.forEach(loc=>{
  const el=document.createElement(loc.href?"a":"div");
  el.className="pin "+(loc.active?"active":"inactive")+(loc.active && loc.tooltipPersistent?" tooltip-persistent":"");
  if(loc.href){ el.href=loc.href; }
  el.innerHTML = pinSVG(loc.active) +
    `<div class="label"><div class="l-country"></div><div class="l-fiber"></div></div>`;
  el.querySelector(".l-country").textContent=loc.name;
  const fiberEl=el.querySelector(".l-fiber");
  if(loc.tooltipLinks.length){
    loc.tooltipLinks.forEach((link,index)=>{
      if(index){ fiberEl.appendChild(document.createTextNode(" · ")); }
      const linkEl=document.createElement("a");
      linkEl.href=link.href;
      linkEl.textContent=link.label;
      fiberEl.appendChild(linkEl);
    });
  } else {
    fiberEl.textContent=loc.display;
  }
  el.style.opacity="0";
  pinsLayer.appendChild(el);
  pinEls.set(loc.key, el);
});

/* ---------- sizing ---------- */
function layout(){
  const boxParent = box.parentElement;
  //const w=window.innerWidth, h=window.innerHeight;
  const w=boxParent.offsetWidth, h=boxParent.offsetHeight;
  size=Math.min(w*0.66, h*0.86, 880);
  size=Math.max(size,300);
  R=size/2;
  box.style.width=size+"px";
  box.style.height=size+"px";
  svg.attr("width",size).attr("height",size).attr("viewBox",`0 0 ${size} ${size}`);
  projection=d3.geoOrthographic()
    .translate([R,R])
    .scale(R-2)
    .rotate(rotation)
    .clipAngle(90);
  path=d3.geoPath(projection);
  render();
}

/* ---------- render ---------- */
function render(){
  projection.rotate(rotation);
  sphereFill.attr("d",path(sphere));
  shadePath.attr("d",path(sphere));
  edgePath.attr("d",path(sphere));
  gratPath.attr("d",path(graticule));

  if(countries.length){
    const base=[], src=[];
    const active=[];
    countries.forEach(f=>{
      if(LOCATIONS.some(location=>location.active && location.id===f.id)){ active.push(f); }
      else if(SOURCE_IDS.has(f.id)){ src.push(f); }
      else { base.push(f); }
    });
    landBase.attr("d",path({type:"FeatureCollection",features:base}));
    landSrc.attr("d",path({type:"FeatureCollection",features:src}));
    landActive.attr("d",path({type:"FeatureCollection",features:active}));
  }
  positionPins();
}

/* ---------- pins ---------- */
const center=()=>[-rotation[0],-rotation[1]];
function positionPins(){
  const c=center();
  LOCATIONS.forEach(loc=>{
    const el=pinEls.get(loc.key);
    const dist=d3.geoDistance(loc.coords,c);          // 0 (front) .. PI (back)
    const visible = dist < Math.PI/2 - 0.02;
    let op=0;
    if(visible){
      // fade out near the limb
      op = Math.min(1, (Math.PI/2 - dist)/0.30);
    }
    if(op<=0.01){
      el.style.opacity="0";
      el.style.pointerEvents="none";
      return;
    }
    const p=projection(loc.coords);
    if(!p){ el.style.opacity="0"; el.style.pointerEvents="none"; return; }
    el.style.left=p[0]+"px";
    el.style.top=p[1]+"px";
    el.style.opacity=loc.active?1:String(op);
    el.style.pointerEvents=op>0.4?"auto":"none";
    // depth: nearer pins sit above
    el.style.zIndex=loc.active?6:String(Math.round((Math.PI/2-dist)*30)+1);
  });
}

/* ---------- drag to spin ---------- */
let dragging=false, dragMoved=false, dragStart=null, last=null, activePointerId=null;
const DRAG_THRESHOLD=5;
function toRot(dx,dy){
  const k=0.30*(420/size+0.6);
  rotation[0]+=dx*k;
  rotation[1]=Math.max(-82,Math.min(82,rotation[1]-dy*k));
}
box.addEventListener("pointerdown",e=>{
  if(dragging || e.button!==0) return;
  dragMoved=false;
  dragging=true;
  activePointerId=e.pointerId;
  dragStart=[e.clientX,e.clientY];
  last=dragStart;
});
window.addEventListener("pointermove",e=>{
  if(!dragging || e.pointerId!==activePointerId) return;
  if(!dragMoved && Math.hypot(e.clientX-dragStart[0],e.clientY-dragStart[1])<DRAG_THRESHOLD) return;
  if(!dragMoved){
    dragMoved=true;
    box.classList.add("dragging");
    box.setPointerCapture(e.pointerId);
    hideHint();
    stopIntro();
  }
  toRot(e.clientX-last[0], e.clientY-last[1]);
  last=[e.clientX,e.clientY];
  render();
});
function endDrag(e){
  if(!dragging || e.pointerId!==activePointerId) return;
  dragging=false;
  activePointerId=null;
  dragStart=null;
  last=null;
  box.classList.remove("dragging");
}
window.addEventListener("pointerup",endDrag);
window.addEventListener("pointercancel",endDrag);

let hintHidden=false;
function hideHint(){ if(!hintHidden){hintHidden=true;hintEl.style.opacity="0";} }
setTimeout(hideHint,6000);

/* prevent navigation if the user was dragging the globe */
pinsLayer.addEventListener("click",e=>{
  const a=e.target.closest("a");
  if(a && dragMoved){ e.preventDefault(); }
},true);

/* ---------- intro spin to the active origin ---------- */
let introTimer=null;
function stopIntro(){ if(introTimer){introTimer.stop();introTimer=null;} }
function intro(){
  const start=rotation.slice();
  const dur=1700;
  const ease=d3.easeCubicInOut;
  const interpL=d3.interpolate(start[0],TARGET[0]);
  const interpP=d3.interpolate(start[1],TARGET[1]);
  introTimer=d3.timer(elapsed=>{
    const t=Math.min(1,elapsed/dur);
    const e=ease(t);
    rotation[0]=interpL(e);
    rotation[1]=interpP(e);
    render();
    if(t>=1){ introTimer.stop(); introTimer=null; }
  });
}

/* ---------- load real geography ---------- */
window.addEventListener("resize",layout);
layout();

fetch("https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json").then(response=>response.json())
  .then(world=>{
    const fc=topojson.feature(world,world.objects.countries);
    countries=fc.features;
    document.getElementById("loading").style.display="none";
    render();
    intro();
  })
  .catch(err=>{
    document.getElementById("loading").textContent="Could not load map data";
    console.error(err);
  });
});

/**** SLIDESHOW *****/
(function () {
  const root    = document.getElementById('slideshow');
  const medias  = [...document.querySelectorAll('.media-slide')];
  const texts   = [...document.querySelectorAll('.text-slide')];
  const fill    = document.getElementById('fill');
  const curEl   = document.getElementById('cur');
  const totalEl = document.getElementById('total');
  const N        = medias.length;
  const DURATION = 5600;        // ms per slide
  const pad = (n) => String(n + 1).padStart(2, '0');

  let index = 0;
  try { const v = parseInt(localStorage.getItem('bts_index'), 10); if (!isNaN(v) && v >= 0 && v < N) index = v; } catch (e) {}
  let timer = null;
  let rafId = null;
  let startAt = 0;
  let paused = false;
  let userPaused = false;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  totalEl.textContent = '/ ' + pad(N - 1);

  function render() {
    medias.forEach((m, i) => m.classList.toggle('is-active', i === index));
    texts.forEach((t, i)  => t.classList.toggle('is-active', i === index));
    curEl.textContent = pad(index);
    try { localStorage.setItem('bts_index', index); } catch (e) {}
  }

  function go(to, resume = true) {
    index = (to + N) % N;
    render();
    if (resume && !userPaused) restartTimer();
    else fill.style.transform = 'scaleX(0)';
  }
  const next = (r) => go(index + 1, r);
  const prev = (r) => go(index - 1, r);

  /* ---- auto-advance with progress fill ---- */
  function restartTimer() {
    clearTimeout(timer);
    cancelAnimationFrame(rafId);
    if (reduce) { fill.style.transform = 'scaleX(0)'; return; }
    startAt = performance.now();
    paused = false;
    timer = setTimeout(() => next(true), DURATION);
    tickFill();
  }
  function tickFill() {
    cancelAnimationFrame(rafId);
    const loop = (now) => {
      if (paused) return;
      const p = Math.min(1, (now - startAt) / DURATION);
      fill.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      if (p < 1) rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
  }

  /* ---- pause on hover ---- */
  function pause() {
    if (paused || reduce) return;
    paused = true;
    clearTimeout(timer);
    cancelAnimationFrame(rafId);
  }
  function play() {
    if (userPaused || !paused || reduce) return;
    const p = parseFloat(fill.style.transform.replace(/[^0-9.]/g, '')) || 0;
    startAt = performance.now() - p * DURATION;
    paused = false;
    clearTimeout(timer);
    timer = setTimeout(() => next(true), DURATION * (1 - p));
    tickFill();
  }

  document.getElementById('next').addEventListener('click', () => next(true));
  document.getElementById('prev').addEventListener('click', () => prev(true));

  const toggleBtn = document.getElementById('toggle');
  toggleBtn.addEventListener('click', () => {
    userPaused = !userPaused;
    toggleBtn.classList.toggle('is-paused', userPaused);
    toggleBtn.setAttribute('aria-label', userPaused ? 'Riprendi' : 'Pausa');
    if (userPaused) pause();
    else play();
  });
  root.addEventListener('mouseenter', pause);
  root.addEventListener('mouseleave', play);

  window.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); next(true); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); prev(true); }
  });

  /* ---- horizontal swipe / drag ---- */
  const SWIPE_THRESHOLD = 48;
  const SWIPE_AXIS_THRESHOLD = 8;
  let swipePointerId = null;
  let swipeStartX = 0;
  let swipeStartY = 0;
  let swipeAxis = null;
  let suppressClickUntil = 0;

  function resetSwipe(resume = false) {
    swipePointerId = null;
    swipeAxis = null;
    root.classList.remove('is-dragging');
    if (resume) play();
  }

  root.addEventListener('pointerdown', (e) => {
    if (swipePointerId !== null || (e.pointerType === 'mouse' && e.button !== 0)) return;
    if (e.target.closest('button, a, input, select, textarea')) return;

    swipePointerId = e.pointerId;
    swipeStartX = e.clientX;
    swipeStartY = e.clientY;
    swipeAxis = null;
  });

  root.addEventListener('pointermove', (e) => {
    if (e.pointerId !== swipePointerId) return;

    const dx = e.clientX - swipeStartX;
    const dy = e.clientY - swipeStartY;

    if (!swipeAxis) {
      if (Math.hypot(dx, dy) < SWIPE_AXIS_THRESHOLD) return;
      swipeAxis = Math.abs(dx) > Math.abs(dy) ? 'horizontal' : 'vertical';

      if (swipeAxis === 'horizontal') {
        root.classList.add('is-dragging');
        root.setPointerCapture(e.pointerId);
        pause();
      }
    }

    if (swipeAxis === 'horizontal') e.preventDefault();
  });

  root.addEventListener('pointerup', (e) => {
    if (e.pointerId !== swipePointerId) return;

    const dx = e.clientX - swipeStartX;
    const dy = e.clientY - swipeStartY;
    const isSwipe = swipeAxis === 'horizontal'
      && Math.abs(dx) >= SWIPE_THRESHOLD
      && Math.abs(dx) > Math.abs(dy);

    if (isSwipe) {
      suppressClickUntil = Date.now() + 400;
      if (dx < 0) next(true);
      else prev(true);
      resetSwipe(false);
    } else {
      resetSwipe(swipeAxis === 'horizontal');
    }
  });

  root.addEventListener('pointercancel', (e) => {
    if (e.pointerId === swipePointerId) resetSwipe(swipeAxis === 'horizontal');
  });

  root.addEventListener('click', (e) => {
    if (Date.now() < suppressClickUntil) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  root.addEventListener('dragstart', (e) => e.preventDefault());

  render();
  restartTimer();
})();

/**** VIDEO AUDIO TOGGLE *****/
(function () {
  document.querySelectorAll('.luxury-videosection-video').forEach((section) => {
    const video = section.querySelector('video');
    const button = section.querySelector('.luxury-videosection-audio-toggle');
    if (!video || !button) return;

    function updateButton() {
      const isMuted = video.muted;
      button.classList.toggle('is-muted', isMuted);
      button.setAttribute('aria-pressed', String(!isMuted));
      button.setAttribute('aria-label', isMuted
        ? (section.dataset.unmuteLabel || 'Attiva audio')
        : (section.dataset.muteLabel || 'Disattiva audio'));
    }

    video.muted = true;
    video.defaultMuted = true;

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) video.play().catch(() => {});
          else video.pause();
        });
      }, { threshold: 0.2 });
      observer.observe(video);
    } else {
      video.play().catch(() => {});
    }

    button.addEventListener('click', () => {
      video.muted = !video.muted;
      if (!video.muted) video.play().catch(() => {});
      updateButton();
    });
    video.addEventListener('volumechange', updateButton);
    updateButton();
  });
})();
